import React from 'react';
import { Notifications } from './components/Notifications';
import { Profile } from './components/Profile';

import { Container, Section } from './styles';

const Sector = () => {
  return <p className="p2 ifpa-bold">Sistema</p>;
};

export const Header: React.FC = () => {
  return (
    <Container>
      <Sector />
      <Section>
        <span />
        <Notifications />
        <span />
        <Profile />
      </Section>
    </Container>
  );
};
